(() => {
  const pad = (n) => (n < 10 ? `0${n}` : `${n}`);

  const getLocale = (el) => el.getAttribute("data-locale") || "es-MX";
  const getDeliveryDays = (el) => {
    const v = parseInt(el.getAttribute("data-delivery-days") || "2", 10);
    return Number.isFinite(v) ? v : 2;
  };

  const fmtDayMonth = (d, locale) => {
    const day = new Intl.DateTimeFormat(locale, { day: "numeric" }).format(d);
    const month = new Intl.DateTimeFormat(locale, { month: "long" }).format(d);
    return { day, month };
  };

  // Timer 1: hasta fin de hoy (pedido)
  const secondsToEndOfDay = () => {
    const now = new Date();
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
    return Math.max(0, Math.floor((end - now) / 1000));
  };

  // Timer 2: hasta 00:00 del día de entrega (inicio del día)
  const secondsToDeliveryDayStart = (deliveryDays) => {
    const now = new Date();
    const target = new Date(now.getFullYear(), now.getMonth(), now.getDate() + deliveryDays, 0, 0, 0);
    return Math.max(0, Math.floor((target - now) / 1000));
  };

  const renderDHMS = (sec) => {
    const d = Math.floor(sec / 86400);
    const hrs = Math.floor((sec % 86400) / 3600);
    const mins = Math.floor((sec % 3600) / 60);
    const secs = sec % 60;

    // “2d 6h 14m” (compacto)
    if (d > 0) return `${d}d ${hrs}h ${mins}m`;
    return `${hrs}h ${mins}m ${pad(secs)}s`;
  };

  // Barra: progreso REAL hacia la entrega (se mueve más perceptible)
  const deliveryProgressPct = (deliveryDays) => {
    const total = Math.max(1, deliveryDays * 86400);
    const remaining = secondsToDeliveryDayStart(deliveryDays);
    const elapsed = Math.max(0, total - remaining);
    let pct = (elapsed / total) * 100;

    // límites estéticos
    pct = Math.max(6, Math.min(98, pct));
    return pct;
  };

  const tick = (root) => {
    const locale = getLocale(root);
    const deliveryDays = getDeliveryDays(root);

    // Elements
    const orderEl = root.querySelector("[data-rz-order]");
    const deliveryEl = root.querySelector("[data-rz-delivery]");
    const dateEl = root.querySelector("[data-rz-date]");
    const bar = root.querySelector("[data-rz-bar]");
    const marker = root.querySelector("[data-rz-dot]");
    const pctEl = root.querySelector("[data-rz-pct]");

    // Fecha entrega
    if (dateEl && !dateEl.dataset.rzDone) {
      const now = new Date();
      const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + deliveryDays);
      const { day, month } = fmtDayMonth(d, locale);
      dateEl.textContent = `${day} de ${month}`;
      dateEl.dataset.rzDone = "1";
    }

    // Timer pedido
    if (orderEl) {
      orderEl.textContent = renderDHMS(secondsToEndOfDay());
    }

    // Timer entrega
    const remDelivery = secondsToDeliveryDayStart(deliveryDays);
    if (deliveryEl) {
      deliveryEl.textContent = `Llega en: ${renderDHMS(remDelivery)}`;
    }

    // Barra entrega
    const pct = deliveryProgressPct(deliveryDays);
    if (bar) bar.style.width = `${pct.toFixed(2)}%`;
    if (marker) marker.style.left = `${pct.toFixed(2)}%`;
    if (pctEl) pctEl.textContent = `${pct.toFixed(0)}%`;
  };

  const initOne = (root) => {
    if (!root) return;

    // limpia interval anterior si el editor recarga
    if (root.dataset.rzInterval) {
      clearInterval(parseInt(root.dataset.rzInterval, 10));
      delete root.dataset.rzInterval;
    }

    tick(root);
    const iv = setInterval(() => tick(root), 1000);
    root.dataset.rzInterval = String(iv);
  };

  const boot = () => {
    document.querySelectorAll("[data-rideez-urgency]").forEach(initOne);
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:reorder", boot);
})();
